import { render } from "./Gallery.vue?vue&type=template&id=1a7b66ec&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=1a7b66ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a7b66ec"

export default script